import { generateDateRangeSet } from './dateRange';

type Period = { start: string; end: string };

export type QuarterlyStats = {
    days: number;
    hours: number;
};

const MONDAY = 1;
const FRIDAY = 5;
const SATURDAY = 6;

const HOURS_5D_NORMAL = 8;
const HOURS_6D_MON_TO_FRI = 7;
const HOURS_6D_SATURDAY = 5;
const HOURS_BEFORE_HOLIDAY = 1;

export function computeQuarterlyStats(
    year: number,
    holidays: Map<string, string>,
    periods: Period[] = []
): { quarters5d: QuarterlyStats[]; quarters6d: QuarterlyStats[] } {

    const quarters5d: QuarterlyStats[] = Array.from({ length: 4 }, () => ({ days: 0, hours: 0 }));
    const quarters6d: QuarterlyStats[] = Array.from({ length: 4 }, () => ({ days: 0, hours: 0 }));

    const periodDates = new Set<string>();
    periods.forEach(({ start, end }) => {
        generateDateRangeSet(start, end).forEach(d => periodDates.add(d));
    });

    for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
        const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

        for (let day = 1; day <= daysInMonth; day++) {
            const mm = String(monthIndex + 1).padStart(2, '0');
            const dd = String(day).padStart(2, '0');
            const dateStr = `${year}-${mm}-${dd}`;

            if (holidays.has(`${mm}-${dd}`) || periodDates.has(dateStr)) continue;

            const date = new Date(year, monthIndex, day);
            const dow = date.getDay();
            const quarter = Math.floor(monthIndex / 3);

            const nextDay = new Date(year, monthIndex, day + 1);
            const nextKey = `${String(nextDay.getMonth() + 1).padStart(2, '0')}-${String(nextDay.getDate()).padStart(2, '0')}`;
            const isBeforeHoliday = holidays.has(nextKey);

            if (dow >= MONDAY && dow <= FRIDAY) {
                const hours5d = HOURS_5D_NORMAL - (isBeforeHoliday ? HOURS_BEFORE_HOLIDAY : 0);
                quarters5d[quarter].days += 1;
                quarters5d[quarter].hours += hours5d;
            }

            if (dow >= MONDAY && dow <= SATURDAY) {
                let hours6d = dow >= MONDAY && dow <= FRIDAY ? HOURS_6D_MON_TO_FRI : HOURS_6D_SATURDAY;
                if (isBeforeHoliday) hours6d -= HOURS_BEFORE_HOLIDAY;
                quarters6d[quarter].days += 1;
                quarters6d[quarter].hours += hours6d;
            }
        }
    }

    return { quarters5d, quarters6d };
}
